const socketTypes = {
  CONNECT_SOCKET: 'CONNECT_SOCKET',
  DISCONNECT_SOCKET: 'DISCONNECT_SOCKET',
};

export default socketTypes;
